import { AxiosGet } from "../../helpers/microserviceAPIs"
import { telerecoveryApiUrl } from "../../config/microservicesUrls"

const api_url = telerecoveryApiUrl()

export async function telerecoveryApiGetIsActive(jwt, organization_id) {
  const res = await AxiosGet(
    jwt,
    `${api_url}/Numbers/isActiveOrg?organizationId=${organization_id}`
  )
  if (res === null) {
    throw new Error(`Unable to confirm telerecovery status for organization`)
  }
  return res
}
